import { IDocFieldHandler } from "./IDocFieldHandler";
import { IDHFSectionOptions } from "../../PluginManagerDocuments";
import { IAnyMap } from "../../../../globals";
import { ITableOfContentOptions } from "./TableOfContentDocFieldHandler";
import { GenericDocAbstractFieldHandler } from "./GenericDocAbstractFieldHandler";

export interface IItemIndexOptions extends IDHFSectionOptions {
    format: string;
}

export const ITEM_INDEX_FORMAT = '\\e "\\t" \\c "1"';

export class ItemIndexDocFieldHander extends GenericDocAbstractFieldHandler implements IDocFieldHandler {
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    dhfFieldConfig: IAnyMap;

    getXmlValue(): string {
        let controllerConfig = this.dhfFieldConfig;
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (this.dhfFieldConfig == undefined) {
            controllerConfig = this.getDefaultConfig();
        }
        let options: ITableOfContentOptions = { format: controllerConfig.format };
        return JSON.stringify([options]);
    }

    getDefaultConfig(): IItemIndexOptions {
        return { format: ITEM_INDEX_FORMAT };
    }
}
